/* eslint no-param-reassign: "off", no-console: "off" */
const adminRoleStore = {
  state: {
    permissions: [],
    roles: [],
    role: null,
    rolesLoading: false
  },
  mutations: {
    fetchPermissions(state, payload) {
      state.permissions = payload;
    },
    fetchRoles(state, payload) {
      state.roles = payload;
    }
  },
  actions: {
    async fetchPermissions({ commit }) {
      try {
        const res = await fetch('/v2/info/permissions');
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchPermissions', data);
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    async fetchRoles({ state, commit }) {
      try {
        state.rolesLoading = true;
        const res = await fetch('/v2.1/roles');
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchRoles', data);
        state.rolesLoading = false;
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    // eslint-disable-next-line no-empty-pattern
    async fetchRole({}, payload) {
      try {
        const res = await fetch(`/v2.1/roles/${payload.id}`);
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        return data;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    }
  },
  getters: {

  }
}
export default adminRoleStore;
